import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtKanaBehavior } from "./PtKanaBehavior";

/** HIS項目患者カナ・名を生成する */
export class PtKanaMeiBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_KANA_MEI";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtKanaMeiBehavior.Key).map(x => x.value);
    const behavior = new PtKanaBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const mei = values.map(x => StringUtility.getTextAfterSpace(x));
    const data = itemValues.length > 0 ? itemValues : mei;
    return new HisInformationTextValue(PtKanaMeiBehavior.Key, data);
  }
}
